import { Controller } from "@hotwired/stimulus"

// Keeps the format value options in sync with the chosen format group
export default class extends Controller {
  static targets = ["group", "value"]

  connect() {
    // select2 does not dispatch a native change event, so bind its jQuery event too
    this.select2Handler = () => this.filterValues()
    $(this.groupTarget).on("select2:select select2:clear", this.select2Handler)

    this.filterValues()
  }

  disconnect() {
    $(this.groupTarget).off("select2:select select2:clear", this.select2Handler)
  }

  filterValues() {
    const selectedGroup = this.groupTarget.value

    Array.from(this.valueTarget.querySelectorAll("optgroup")).forEach((optgroup) => {
      const matches = selectedGroup === "" || optgroup.dataset.formatGroup === selectedGroup
      optgroup.hidden = !matches

      Array.from(optgroup.querySelectorAll("option")).forEach((option) => {
        option.disabled = !matches
        if (!matches && option.selected) this.valueTarget.value = ""
      })
    })
  }
}
